'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ChecklistsOutline = function ChecklistsOutline(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 120 120"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("rect", {
    width: "120px",
    height: "120px",
    fill: "#ECEFF1",
    rx: "16"
  }), React__default["default"].createElement("path", {
    fill: "#000",
    "fill-opacity": ".12",
    d: "M42.353 73.333l2.353 2.353-10.965 10.98-7.074-7.058 2.353-2.353 4.721 4.706 8.612-8.628zM90 76.667v6.666H53.333v-6.666H90zM42.353 53.333l2.353 2.353-10.965 10.98-7.074-7.058 2.353-2.353 4.721 4.706 8.612-8.628zM90 56.667v6.666H53.333v-6.666H90zM42.353 33.333l2.353 2.353-10.965 10.98-7.074-7.058 2.353-2.353 4.721 4.706 8.612-8.628zM90 36.667v6.666H53.333v-6.666H90z"
  })));
};

var ChecklistsOutline$1 = iconStyles()(ChecklistsOutline);

module.exports = ChecklistsOutline$1;
